import { render, staticRenderFns } from "./MyEmail.vue?vue&type=template&id=000c6a07"
import script from "./MyEmail.vue?vue&type=script&lang=js"
export * from "./MyEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports